import { RecentlyViewed } from '@theme/recently-viewed-products';
import { sectionRenderer } from '@theme/section-renderer';

class ChuttyRecentlyViewed extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';
    this.#loadProducts();
  }

  async #loadProducts() {
    const sectionId = this.dataset.sectionId;
    const currentProductId = this.dataset.currentProductId;
    const maxProducts = Number(this.dataset.maxProducts || 4);
    const section = this.closest('.chutty-recently-viewed');

    if (!sectionId) return;

    let viewedProducts = RecentlyViewed.getProducts();

    if (currentProductId) {
      viewedProducts = viewedProducts.filter((id) => String(id) !== String(currentProductId));
    }

    viewedProducts = viewedProducts.slice(0, maxProducts);

    if (viewedProducts.length === 0) {
      section?.setAttribute('hidden', '');
      return;
    }

    const searchUrl = new URL(window.Theme?.routes?.search_url || '/search', window.location.origin);
    searchUrl.searchParams.set(
      'q',
      viewedProducts.map((id) => `id:${id}`).join(' OR ')
    );
    searchUrl.searchParams.set('resources[type]', 'product');

    try {
      const sectionHtml = await sectionRenderer.getSectionHTML(sectionId, false, searchUrl);
      const parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
      const grid = parsed.querySelector('[data-chutty-rv-grid]');
      const localGrid = this.querySelector('[data-chutty-rv-grid]');

      if (!grid || !localGrid) {
        section?.setAttribute('hidden', '');
        return;
      }

      const hasProducts = grid.querySelector('.chutty-recently-viewed__item');

      if (!hasProducts) {
        section?.setAttribute('hidden', '');
        return;
      }

      localGrid.innerHTML = grid.innerHTML;
      section?.removeAttribute('hidden');
    } catch (_error) {
      section?.setAttribute('hidden', '');
    }
  }
}

if (!customElements.get('chutty-recently-viewed')) {
  customElements.define('chutty-recently-viewed', ChuttyRecentlyViewed);
}
